import { render, staticRenderFns } from "./switch-status.vue?vue&type=template&id=18cf7156"
import script from "./switch-status.vue?vue&type=script&lang=ts"
export * from "./switch-status.vue?vue&type=script&lang=ts"
import style0 from "./switch-status.vue?vue&type=style&index=0&id=18cf7156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports